import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AiSourcingHandlerService {

  constructor() { }

  private currentDisplayPage: Subject<any> = new Subject();

  private progressCompletedSource = new Subject<void>();

  // Observable for siblings to subscribe
  progressCompleted$ = this.progressCompletedSource.asObservable();

  notifyProgressCompleted() {
    this.progressCompletedSource.next(undefined as any);
  }

  get getDisplayPageEvent(): Observable<any> {
    return this.currentDisplayPage.asObservable();
  }

  setDisplayPageEvent(page: String) {
    this.currentDisplayPage.next(page);
  }

  /** Setter getter methos to know the current tab is evaluation criteria or not on project details view */
  private isEvaluationCriteriaTab: Subject<any> = new Subject();

  get getEvaluationTabEvent(): Observable<any> {
    return this.isEvaluationCriteriaTab.asObservable();
  }

  setEvaluationTabEvent(evaluationtab: Boolean) {
    this.isEvaluationCriteriaTab.next(evaluationtab);
  }

  /** Method to handle enter manual event */
  private enterManualEvent: Subject<any> = new Subject();

  get getEnterManualEvent() {
    return this.enterManualEvent.asObservable();
  }

  setEnterManualEvent(data: boolean) {
    this.enterManualEvent.next(data);
  }

  private filterData: any = {};

  get fetchProjectDetails() {
    return this.filterData;
  }

  setProjectDetails(filterData: any) {
    this.filterData = Object.assign({}, filterData);
  }

  private projectCountEvent: Subject<any> = new Subject();

  get getProjectCountEvent() {
    return this.projectCountEvent.asObservable();
  }

  setProjectCountEvent(data: any) {
    this.projectCountEvent.next(data);
  }

  private aiStatsSubject: Subject<[any, any, any]> = new Subject();

  emitAIStatsObject(statsObject: [any, any, any]) {
    this.aiStatsSubject.next(statsObject);
  }

  get statsAIUpdateEvent(): Observable<[any, any, any]> {
    return this.aiStatsSubject.asObservable();
  }

  private clearFilterSubject: Subject<any> = new Subject();

  get clearFilterEvent(): Observable<any> {
    return this.clearFilterSubject.asObservable();
  }

  setClearFilterEvent(data: any) {
    this.clearFilterSubject.next(data);
  }



  /** Method to handle Show filter component */
  private showFilterData: Subject<any> = new Subject();

  get getShowFilterComponent() {
    return this.showFilterData.asObservable();
  };

  setShowFilterComponent(data: boolean) {
    this.showFilterData.next(data);
  };

  private dataSource = new BehaviorSubject<any>(null);
  data$ = this.dataSource.asObservable(); // components will subscribe to this

  // set/update value
  setData(value: any) {
    this.dataSource.next(value);
  }

  // clear/reset value
  clearData() {
    this.dataSource.next(null);
  }

  // get current value without subscribing
  getCurrentValue() {
    return this.dataSource.getValue();
  }


}
